import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BrandTooltip from 'components/consumer/BrandTooltip';
import PDPNotification from 'components/consumer/PDP/PDPNotification';
import IconQuickship from 'components/icons/iconQuickship';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import { PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePDPLeadTime from 'data-hooks/usePDPLeadTime';
import useScreen from 'hooks/useScreen';
import BrowserOnly from 'components/consumer/BrowserOnly';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import PDPZipCodeEditLocation from '../PDPZipCodeEditLocation';
const PDPLeadTimeUI = t0 => {
  const $ = _c(44);
  const {
    mode,
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const {
    shippingLeadTime,
    leadTimeLoading
  } = usePDPLeadTime();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const userLocation = useUserLocation();
  const isUserInUS = userLocation?.country === "United States";
  const zipCodeFromUser = useZipCodeFromUser();
  const isRTS = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  const isDL = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const [showMobileTooltip, setShowMobileTooltip] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isTooltipOpen => {
      setShowMobileTooltip(isTooltipOpen);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onTooltipToggle = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setShowMobileTooltip(false);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const closeTooltip = t3;
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  const isUnavailableToShip = !!zipCodeFromUser && !isZipCodeFromUserServiceable;
  const t4 = !isLayoutRevamp;
  let t5;
  if ($[2] !== t4) {
    t5 = classNames("flex flex-row items-center min-h-[15px] mt-4 justify-center text-gray text-base text-ellipsis whitespace-nowrap flex-wrap max-[767px]:mr-0", {
      "max-[767px]:[justify-content:left]": t4
    });
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isUnavailableToShip || $[5] !== zipCodeFromUser) {
    t6 = isUnavailableToShip && <span>Unavailable to ship to {zipCodeFromUser}.</span>;
    $[4] = isUnavailableToShip;
    $[5] = zipCodeFromUser;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isDL || $[8] !== isRTS || $[9] !== isUnavailableToShip || $[10] !== leadTimeLoading || $[11] !== shippingLeadTime) {
    t7 = !isUnavailableToShip && (!!leadTimeLoading || !!shippingLeadTime) && <>{!!isRTS && <span className="flex items-center mr-[2px]"><IconQuickship />{" "}</span>}<span className="mr-[3px] text-gray">{isRTS ? "Ready to ship " : isDL ? "Ship time" : "Available to ship "}</span></>;
    $[7] = isDL;
    $[8] = isRTS;
    $[9] = isUnavailableToShip;
    $[10] = leadTimeLoading;
    $[11] = shippingLeadTime;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isUnavailableToShip || $[14] !== leadTimeLoading) {
    t8 = !isUnavailableToShip && !!leadTimeLoading && <BrowserOnly><ProgressLoaderDots inline={true} grey={true} className="m-0 mx-1" /></BrowserOnly>;
    $[13] = isUnavailableToShip;
    $[14] = leadTimeLoading;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isDL || $[17] !== isUnavailableToShip || $[18] !== leadTimeLoading || $[19] !== shippingLeadTime) {
    t9 = !isUnavailableToShip && !leadTimeLoading && !!shippingLeadTime && <span>{isDL ? "TBD" : `in ${shippingLeadTime}`}</span>;
    $[16] = isDL;
    $[17] = isUnavailableToShip;
    $[18] = leadTimeLoading;
    $[19] = shippingLeadTime;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span> </span>;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isUnavailableToShip || $[23] !== isUserInUS || $[24] !== leadTimeLoading || $[25] !== shippingLeadTime) {
    t11 = (isUnavailableToShip || !isUnavailableToShip && (!!leadTimeLoading || !!shippingLeadTime) || !isUserInUS) && <PDPZipCodeEditLocation />;
    $[22] = isUnavailableToShip;
    $[23] = isUserInUS;
    $[24] = leadTimeLoading;
    $[25] = shippingLeadTime;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== isUnavailableToShip || $[28] !== mode) {
    t12 = !isUnavailableToShip && <div><BrandTooltip className="bottom-0.5" direction={mode === "quickview" ? "top" : "bottom"} hideIconOnOpenMobile={true} iconClassName="!top-[3px]" iconSize="big" inactiveOnMobile={true} mode={mode} onTooltipToggle={onTooltipToggle} openOnHover={true} showCloseButton={false}>{"Please note, this is the estimated time it will take to build and prepare your order for shipment. This is not a delivery date. Full delivery estimates are shown once you're done adding products to your order at checkout."}</BrandTooltip></div>;
    $[27] = isUnavailableToShip;
    $[28] = mode;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t13 = <div className={t5}>{t6}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== isMobileOrTablet || $[39] !== showMobileTooltip) {
    t14 = showMobileTooltip && isMobileOrTablet && <PDPNotification heading="Ready to Ship" subheading="Please note, this is the estimated time it will take to build and prepare your order for shipment. This is not a delivery date. Full delivery estimates are shown once you're done adding products to your order at checkout." onClose={closeTooltip} />;
    $[38] = isMobileOrTablet;
    $[39] = showMobileTooltip;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t13 || $[42] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};
PDPLeadTimeUI.propTypes = {
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  isLayoutRevamp: PropTypes.bool
};
export default PDPLeadTimeUI;